import { NgModule, DoBootstrap, Injector } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { AppComponent } from './app.component';
import {
  appConfig,
  errorInterceptor,
  headerInterceptorFn,
  patchDomHandlerGetScrollableParents,
} from '@everymatrix-base-components/utils';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { MessageService } from 'primeng/api';
import { createCustomElement } from '@angular/elements';

@NgModule({
  imports: [BrowserModule, AppComponent],
  providers: [
    MessageService,
    ...appConfig.providers,
    provideHttpClient(
      withInterceptors([headerInterceptorFn, errorInterceptor])
    )
  ],
})
export class AppModule implements DoBootstrap {
  constructor(private injector: Injector) {
    const element = createCustomElement(AppComponent, {
      injector: this.injector,
    });
    if (!customElements.get('everymatrix-mm-verification-report')) {
      customElements.define('everymatrix-mm-verification-report', element);
    }

    patchDomHandlerGetScrollableParents();
  }

  // eslint-disable-next-line @angular-eslint/no-empty-lifecycle-method,@typescript-eslint/no-empty-function
  ngDoBootstrap(): void {}
}
